module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keyword":"Keyword","volume":"Volume","cpc":"CPC"},"fr":{"keyword":"Mot clé","volume":"Volume","cpc":"CPC"},"de":{"keyword":"Stichwort","volume":"Volumen","cpc":"CPC"}}')
  delete Component.options._Ctor
}
